<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MI1TVm/tc-custom/9781429949422.jpg?1733081017918" alt="This image is the cover for the book Gridlock"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gridlock
      </h1>
      <p class="bookDescription body article font2">
        <p>Two Iranian agents hand over one million dollars to a Russian engineer for a thumbdrive. The drive contains a deadly computer virus that could shut down all electrical power in the United States at a keystroke.<br/><br/>In rural North Dakota, a lineman is electrocuted, and the local cop sent to investigate is shot to death. As rolling electrical blackouts begin to shut down major US cities, the war for energy domination begins.<br/>Two nations are behind this deadly attack: Venezuela and Iran, intent on destroying the present world order and bringing an arrogant America to its knees. Their agent of terror is Yuri Makarov, a former Spetsnaz officer, the best of the best among the shadow world of killers for hire. When governments are powerless to stop such a man from sending the United States back to the horse-and-buggy era, North Dakota county sheriff Nate Osborne and brash journalist Ashley Borden once again step into the breach. <br/><i>Gridlock </i>is a harrowing near-future thriller from <i>New York Times </i>bestselling duo Senator Byron Dorgan and David Hagberg.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Byron L. Dorgan, David Hagberg
      </h2>
      
      <p class="authorDescription body article"><P>BYRON L. DORGAN served as a congressman and senator for North Dakota for thirty years. He was chairman of Senate committees and subcommittees on the issues of energy, aviation, appropriations, water policy, and Indian affairs. <br><br>DAVID HAGBERG is a former Air Force cryptographer who has traveled extensively in Europe, the Arctic, and the Caribbean. He has published more than seventy novels of suspense, including the bestselling<I> Allah's Scorpion,</I><I>The Expediter</I>, and <I>Abyss.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cd4b8a0